import React, { useState } from "react";
import { Toaster } from "sonner";
import { useI18n } from "@/i18n/I18nProvider";
import { ContactForm } from "@/components/contact/ContactForm";
import { ContactHero, ContactSuccess, PhonesBlock } from "@/components/contact/ContactBlocks";

export default function Contact() {
  const { t, lang } = useI18n();
  const [submitted, setSubmitted] = useState(false);
  return (
    <>
      <Toaster position="top-center" richColors />
      <ContactHero t={t} />
      <section className="bg-[#F4F0E8]">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-16 sm:py-20 grid grid-cols-1 lg:grid-cols-12 gap-16">
          <div className="lg:col-span-7">
            {submitted ? (
              <ContactSuccess t={t} onReset={() => setSubmitted(false)} />
            ) : (
              <ContactForm t={t} lang={lang} onSuccess={() => setSubmitted(true)} />
            )}
          </div>
          <aside className="lg:col-span-5">
            <PhonesBlock t={t} />
          </aside>
        </div>
      </section>
    </>
  );
}
